import * as React from 'react';
import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsxs(React.Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    fillOpacity: ".3",
    d: "M2 22h20V2L2 22z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14 10L2 22h12V10z"
  })]
}), 'SignalCellular2BarTwoTone');